
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDownIec as ObiDownIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-down-iec.js';
 
 
 

 
 export const ObiDownIec = createComponent({
   react: React,
   tagName: 'obi-down-iec',
   elementClass: ObiDownIecElement,
   events: {
     
   }
  });
 
 